// extracted by mini-css-extract-plugin
export default {"form":"Login_form__aduzR","login":"Login_login__ALv8T","input":"Login_input__rKM5x","btnLink":"Login_btnLink__Hg9q0","signup":"Login_signup__1DHcM","btn":"Login_btn__+pmgx"};